import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getLocationById, locationsActions }  from  '../../core/locations'

export class LocationItemRow extends Component {

  componentWillMount() {
    const { user } = this.props
    this.props.loadLocation(this.props.locationId, user.sessionId);
  }

  componentWillUpdate(nextProps, nextState) {
    const { user } = this.props
    this.props.loadLocation(nextProps.locationId, user.sessionId);
  }

  render() {
    const { location } = this.props;

    if (!location) return null;

    let text = location.nombre;
    if (location.provincia && location.provincia.nombre )
      text =  `${text} - ${location.provincia.nombre}`

    return ( <span>{ text }</span> );
  }
}

//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {

  const location = getLocationById(state, props.locationId)
  return {
    locationId: props.locationId,
    location,
    user: state.session.user
  }
};

const mapDispatchToProps = {
  loadLocation: locationsActions.loadLocation,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationItemRow);
